<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Designing the university experience for students to achieve greater persistence and academic success.
            </p>
          </div>
        </div>-->
        <div class="uk-section uk-section-default uk-margin-remove-top uk-padding uk-padding-remove-bottom">
          <div class="uk-container">
              <h1 class="uk-heading-line uk-text-center specHeading">Student Engagement and Retention</h1>
              <div style="padding-right: 150px; padding-left: 150px;">
                <p>The office of Student Engagement and Retention (SEAR) is responsible for creating the first year
                  experience for new students to ensure a smooth transition into university life and persistence through to
                  graduation. At SEAR, we want all our students to achieve success and will collaborate with the various
                  work units across all campuses to ensure that the academic, financial, social, or spiritual issues affecting
                  our students are resolved speedily and satisfactorily.</p>
              </div>

          </div>
        </div>

        <div class="uk-section uk-section-muted uk-padding-remove-top uk-padding-remove-bottom">
          <div class=" uk-background-secondary uk-light uk-padding" style="font-size: 30px; padding: 20px; color: rgb(197,179,88) !important;">
            <div class="uk-container ">
              <p class="uk-text-center uk-text-lead@l uk-text-large@Xl">
                STUDENT TERTIARY EXPERIENCE PROGRAMME (STEP)
              </p>
            </div>
          </div>
          <div class="uk-container">

            <div class="uk-padding uk-background-muted uk-margin-remove-top uk-margin-remove-bottom">
              <div style="padding-right: 100px; padding-left: 100px">
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(3, 56, 96)"><span>Overview</span></h1>
                <p>University first year experience programmes provide engagement opportunities for students which
                  usually translate to student success and higher retention rates. Research confirms that first year students
                  desire a sense of belongingness to remain committed to an institution. The Student Tertiary Experience
                  Programme (STEP) is an expansion of the freshman advisement component of enrolment management at Northern
                  Caribbean University (NCU). It is a collaborative initiative designed to assist students in having greater
                  academic integration, personal, physical, social and spiritual development while making the transition to
                  university life.This will be accomplished via the first year experience programmes endorsed by SEAR including:</p>
                <ul class="uk-list uk-list-bullet">
                  <li>Orientation | Fresh Mingle | Club Events | Freshman Seminar | Outreach activities | Chapel Sessions |
                    Community Projects | Campus/ Town Tours | College Fiestas | Dine & Lyme</li>
                </ul>
                <router-link to="/step" class="uk-button uk-button-secondary uk-text-bold uk-align-right">Read More...</router-link>
              </div>
            </div>
            </div>

          </div>

        <div class="uk-section uk-section-default uk-margin-remove-top uk-padding uk-padding-remove-bottom">
          <div class="uk-container uk-margin-bottom" style="padding-right: 100px; padding-left: 100px">

            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(197,179,88)"><span>Orientation</span></h1>
                <p>Orientation for new students is held at the start of each semester: August for Fall semester, and
                  January for Spring semester. New students are introduced to the university, team members
                  integral to their educational pursuits, and the avenues for ensuring a successful university
                  experience. A university survival kit (USK) and campus map is provided to new students to
                  navigate the pathways of university life. Click here to visit the orientation page. (Create
                  hyperlink, information will be supplied by Student Services).</p>

              </div>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(197,179,88)"><span>Fresh Mingle</span></h1>
                <p>Freshmen are brought together to mingle through games and other activities and enter the
                  Fresh Prince and Princess Culture Competition. A male and female new students are selected
                  based on their awareness of the University activities. The Fresh Prince and Princess will help
                  the office of Student Engagement and Retention (SEAR) to provide greater cultural awareness
                  to new students by participating in office related activities including orientation. </p>
              </div>
            </div>


          </div>
        </div>

        <div class="uk-section uk-section-muted uk-margin-remove-top uk-padding uk-padding-remove-bottom">
          <div class="uk-container uk-margin-bottom" style="padding-right: 200px; padding-left: 200px;">

            <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(3, 56, 96)"><span>Club Involvement</span></h1>
            <p>The University seeks to cater to the holistic development of each student: mental, physical,
              social and spiritual; hence we encourage our students to get involved in the different clubs on
              campus. Each new student is strongly encouraged to join one club from each of the four
              category.
            </p>
            <div class="uk-child-width-1-1@m " uk-grid>
              <h5 class="uk-heading-bullet uk-text-bold uk-text-center" style="font-size: 18px;"><span>Academic (Mental)</span></h5>
              <div>
                <div class="uk-child-width-1-2@m" uk-grid>
               <div>
                <ul class="uk-list" >
                  <li>College of Allied Health and Nursing</li>
                  <li>Northern Caribbean University Nutrition, Dietetics and Food Science Student Association (NCUNDFSSA)</li>
                  <li>Medical Technology Undergraduate Association (MTUA)</li>
                  <li>Nursing Students Association (NSA)</li>
                  <li>College of Business and Hospitality Management</li>
                  <li>Business and Secretarial Student Organization (BASSO)</li>
                  <li>Human Resource Management Association (HRMA)</li>
                  <li>Tourism Action Club (TAC)</li>
                  <li>College of Education and Leadership</li>
                  <li>College of Education and Leadership (CELS)</li>
                  <li>College of Humanities, Behavioural & Social Sciences (HUBSS)</li>
                  <li>Psychology Students Association (PSA)</li>

                </ul>
               </div>
                  <div>
                    <ul class="uk-list">
                      <li>Association of Criminal Justice Students (ACJuS)</li>
                    <li>French Club</li>
                  <li>Spanish Club</li>
                  <li>Social Work Students Association (SWSA)</li>
                  <li>Counselling Students Association (CSA)</li>
                      <li>Literary and Debating Society (LaDS)</li>
                      <li>College of Natural and Applied Sciences</li>
                      <li> Computer Hardware Information Processing Specialists (CHIPS)</li>
                      <li> Northern Caribbean University Science Students Association (NCUSSA)</li>
                      <li>Society of Mathematicians and Engineers (SOME)</li>
                      <li>  School of Religion & Theology</li>
                      <li> Ministerial Association (MA)</li>
                   </ul>
                  </div>
               </div>
                </div>
              </div>
            <div class="uk-child-width-1-3@m " uk-grid>
                  <div>
                    <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>Spiritual</span></h5>
                    <ul class="uk-list" >
                      <li>Central Jamaica Conference (CJC) Club</li>
                      <li>East Jamaica Conference (EJC) Club</li>
                      <li>North Jamaica Conference (NJC) Club (includes students for North East)</li>
                      <li>West Jamaica Conference (WJC) Club</li>
                      <li>Student Association of Literature Evangelists (SALE) Club</li>
                      <li> Spirit of Prophecy (SOP) Club</li>
                    </ul>
                  </div>

                  <div>
                    <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>Social</span></h5>
                    <ul class="uk-list">
                      <li>Dramatists for Christ</li>
                      <li>Excelsior (male residence hall students)</li>
                      <li>International Student Association (ISA)</li>
                      <li>Peer Counsellors</li>
                      <li>Philmelodia (female residence halls students)</li>
                      <li> Rotaract (currently dormant)</li>
                    </ul>
                  </div>

                <div>
                  <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>Sporting Teams (Physical)</span></h5>
                  <ul class="uk-list">
                    <li> Badminton</li>
                    <li> Netball</li>
                    <li> Football (male and female)</li>
                    <li> Basketball</li>
                    <li>Cricket</li>
                    <li>Table Tennis</li>
                    <li>Volleyball</li>
                  </ul>
                </div>
                </div>
              </div>
            </div>

        <div class="uk-section uk-section-default uk-margin-remove-top uk-padding uk-padding-remove-bottom">
          <div class="uk-container uk-margin-bottom" style="padding-right: 100px; padding-left: 100px">

            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(197,179,88)"><span>Campus/ Community Tour</span></h1>
                <p>At each Orientation exercise after we would have congregated with our Freshmen, we embark
                  on a tour of the community and the Campus allowing our students to be able to find their way in
                  and around the Campus and Community.</p>
              </div>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(197,179,88)"><span>Freshman Seminar</span></h1>
                <p>Freshman Seminar is a one credit orientation class designed to help new students to prepare
                  successfully for university life. Topics include note-taking skills, career advising, accessing
                  library resources online, academic records management, STEP, etc. and are presented in an
                  interactive and interesting format by various team members at the institution. The class includes
                  campus and community tours, research walks, and outreach activities. </p>
              </div>
            </div>


          </div>
        </div>

        <div class="uk-section uk-section-muted uk-margin-remove-top uk-padding uk-padding-remove-bottom">
          <div class="uk-container uk-margin-bottom" style="padding-right: 100px; padding-left: 100px">

            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(3, 56, 96)"><span>Dine & Lyme</span></h1>
                <p>This a social event that is geared towards having students enjoy a relaxing lunch hour with
                  music and performance in the school’s Cafeteria - Sorenson Hall - once per month, each
                  semester.
                </p>
              </div>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(3, 56, 96)"><span>College Fiesta</span></h1>
                <p>This event is held each academic year and provides the opportunity for employees and students
                  within each college/ school to connect and unwind in games and fun.</p>
              </div>
            </div>


          </div>
        </div>

        <div class="uk-section uk-section-default uk-margin-remove-top uk-padding uk-padding-remove-bottom">
          <div class="uk-container uk-margin-bottom" style="padding-right: 200px; padding-left: 200px;">

            <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;   color:rgb(197,179,88)"><span>Outreach activities</span></h1>
            <p>New students are given the opportunity to participate in inreach and outreach activities while
              enrolled at NCU. The office of Chaplaincy Services in collaboration with Freshman Seminar
              Class and SEAR will ensure that new students get involved in giving service to others on
              campus and in the local community.
            </p>
            <div class="uk-child-width-1-1@m " uk-grid>
              <div>
                <div class="uk-child-width-1-2@m" uk-grid>
                  <div>
                    <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>In-Reach Activities</span></h5>
                    <ul class="uk-list" >
                      <li> 1. Monday Chapel worship service (2:00 – 3:15 p.m. weekly)</li>
                      <li> 2. Friday evening Vesper service (usually at sunset each week)</li>
                      <li> 3. Pause for Prayer (Weekdays from 11:55 a.m. – 12:00 noon)</li>
                      <li>4. Noon Power Hour prayer and testimony service at the Prayer Garden and the Club
                        Worship Centres (every Monday – Thursday at noon)</li>
                      <li> 5. Upper Room Experience (every Thursday from 6:00 – 8:00 p.m. at LTA-1)</li>
                      <li>6. Bible Study Class (Wednesdays at 2:00 p.m. and by appointment)</li>
                      <li>7. Bible Correspondence Courses (Online and in office)</li>
                      <li> 8. Individual Counselling at Chaplaincy Services</li>
                      <li> 9. Meal assistance from Chaplaincy Services</li>
                      <li> 10. Unit Chaplaincy Program (Unit Chaplains, Chaplain Aides and Class Chaplains) offer
                        friendly source of pastoral support: located in all dormitories and divisions on campus)</li>
                    </ul>
                  </div>
                  <div>
                    <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>Outreach Activities</span></h5>
                    <ul class="uk-list">
                      <li>1. Touch of Faith – hospital visitations</li>
                      <li>2. Loaves of Love – feeding of the homeless at the Park in Mandeville</li>
                      <li>3. Sunshine Band – visits to children’s homes and orphanage ministry</li>
                      <li>4. Prison Ministry – visits to Holding Centres at Police Stations</li>
                      <li> 5. Peer Partners Program – NCU students ministering to students at selected high schools
                      in Manchester</li>
                      <li>6. Taxi Driver Ministry – students conduct devotion with taxi drivers at the university gate at
                      noon</li>
                      <li>7. Youth-Senior Connect – visits to Infirmary and Nursing Homes</li>
                      <li>8. Prayer Ministry – visit to off-campus government agency to conduct brief devotion and
                      prayer</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
           <!-- <div class="uk-child-width-1-3@m " uk-grid>
              <div>
                <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>Spiritual</span></h5>
                <ul class="uk-list" >
                  <li>Central Jamaica Conference (CJC) Club</li>
                  <li>East Jamaica Conference (EJC) Club</li>
                  <li>North Jamaica Conference (NJC) Club (includes students for North East)</li>
                  <li>West Jamaica Conference (WJC) Club</li>
                  <li>Student Association of Literature Evangelists (SALE) Club</li>
                  <li> Spirit of Prophecy (SOP) Club</li>
                </ul>
              </div>

              <div>
                <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>Social</span></h5>
                <ul class="uk-list">
                  <li>Dramatists for Christ</li>
                  <li>Excelsior (male residence hall students)</li>
                  <li>International Student Association (ISA)</li>
                  <li>Peer Counsellors</li>
                  <li>Philmelodia (female residence halls students)</li>
                  <li> Rotaract (currently dormant)</li>
                </ul>
              </div>

              <div>
                <h5 class="uk-heading-bullet uk-text-bold uk-text-left" style="font-size: 18px;"><span>Sporting Teams (Physical)</span></h5>
                <ul class="uk-list">
                  <li> Badminton</li>
                  <li> Netball</li>
                  <li> Football (male and female)</li>
                  <li> Basketball</li>
                  <li>Cricket</li>
                  <li>Table Tennis</li>
                  <li>Volleyball</li>
                </ul>
              </div>
            </div>-->
          </div>
        </div>

        <div class="uk-section uk-section-muted uk-margin-remove-top uk-padding uk-padding-remove-bottom">
          <div class="uk-container uk-margin-bottom" style="padding-right: 100px; padding-left: 100px">

            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px;  color:rgb(3, 56, 96)"><span>Mentorship</span></h1>
                <p>The office of Student Engagement and Retention (SEAR) has developed an integrated first
                  year experience programme dubbed Student Tertiary Experience Programme (STEP) that is
                  aimed at assisting students to progress smoothly through their university education from
                  admission to graduation, and beyond. Each new student is assigned a STEP Brother/ Sister
                  (second or third year student) to provide mentorship guidance as they make the transition from
                  high school to university. The STEP Reps assist new students to enjoy all aspects of their
                  university experience and become product samples for the institution.
                </p>
              </div>
              <div>
                <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(3, 56, 96)"><span>Community Project</span></h1>
                <p>During the Fall and Spring semester the Office of Student Engagement and Retention, along
                  with STEP Volunteers and their assigned siblings (freshmen), will participate in targeted projects
                  in Mandeville and its environs. The community projects can take the form of visits to a Children
                  Homes, Nursing Homes, Clean-up Campaigns at homes of community members, etc.</p>
              </div>
            </div>


          </div>
        </div>

        <div class="uk-padding uk-background-default uk-margin-remove-top uk-margin-remove-bottom">
          <div style="padding-right: 200px; padding-left: 200px">
            <h1 class="uk-heading-line uk-text-center uk-text-bold" style="font-size: 21px; color:rgb(197,179,88)"><span>Sports Day</span></h1>
            <p>Sports Days are held every year during Spring Semester on the Tuesday before Ash
              Wednesday. Freshmen are assigned to their houses by the University Information System
              Services (UNISS) upon registering for classes. The houses are Beaumont (Yellow), Brodie
              (Blue), Chisholm (Red), and Fletcher (Green).</p>
          </div>
        </div>

        <div class="uk-container">
          <router-link to="/step" class="uk-button uk-button-secondary uk-text-bold uk-align-right">View More Information</router-link>
        </div>
      </div>


    </div>

  </transition>
</template>

<script>
    export default {
        name: "sear",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Student Engagement and Retention ',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Department of Student Engagement and Retention at Northern Caribbean University '}
        ]
      }
    }
</script>

'<style scoped>
li{
  line-height: 18px;
  font-size: 15px;
}
</style>
